export default "__VITE_ASSET__CtvPPoHC__"